import { intl } from "src/internationalization/intl";
import { Grid, Typography } from "src/lib/components/basics";

interface IContextLabelProps {
    context: string;
    /** Smaller type for the sent message's own copy of this — the composer bar stays at its normal size. */
    compact?: boolean;
}

/** "Context: {label}" — used both in the composer bar and on an already-sent message.
 * The value line stays on variant="body2" even when compact: "caption" carries its own theme-level
 * font-weight override that fights the bold here, so size is controlled via fontSize instead. */
const ContextLabel = ({ context, compact = false }: IContextLabelProps) => (
    <Grid>
        <Typography
            color="tertiary"
            variant="caption"
            sx={{ display: "block", lineHeight: 1.2, fontSize: compact ? "0.625rem" : undefined }}
        >
            {intl("contextMessage")}:
        </Typography>
        <Typography
            color="tertiary"
            variant="body2"
            sx={{ fontWeight: 600, lineHeight: 1.2, fontSize: compact ? "0.75rem" : undefined }}
        >
            {intl(context, { fallback: context })}
        </Typography>
    </Grid>
);

export { ContextLabel };
